import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { Router, RouterModule } from '@angular/router';
import { User } from '../user.model';
import { UserService } from '../user.service';
import { LoadComponent } from 'src/app/ui-design-library/load/load.component';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'fnsr-user-list',
  standalone: true,
  imports: [LoadComponent, AsyncPipe, RouterModule],
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss']
})
export class UserListComponent {
  users$: Observable<User[]>

  constructor(
    private userService: UserService,
    public router: Router
  ) {
    this.users$ = this.userService.getUsers();
  }
}
